import { create } from 'zustand';
import {format} from "date-fns";
import ExecutionsAPI from "../services/ExecutionsAPI";

export const ORDER_TYPE_PENDING = 'pending';
export const ORDER_TYPE_NOT_DELIVERED = 'not-delivered';
export const ORDER_TYPE_DELIVERED = 'delivered';

export const useStoreExecutions = create((set, get) => ({
    executionsCount: 0,
    executionsInPendingCount: 0,
    executionsInProgressCount: 0,
    executions: [],
    executionsInProgress: [],
    isLoading: false,
    isError: false,
    florist: null,
    type: ORDER_TYPE_PENDING,
    sortType: 'etatextranet',
    sortOrder: 'asc',
    currentPage: 1,
    searchText: '',
    dateStart: '',
    dateEnd: '',
    activeRing: true,
    executionsAutoAcceptedCount: 0,
    setType: (newType) => {
        if (newType !== get().type) {
            set({type: newType});

            if (newType !== 'search') {
                get().setSearchText('');
                get().setDateStart('');
                get().setDateEnd('');
            }
        }
    },
    setSearchText: (newSearchText) => {
        set({searchText: newSearchText});
    },
    setDateStart: (newDateStart) => {
        set({dateStart: newDateStart});
    },
    setDateEnd: (newDateEnd) => {
        set({dateEnd: newDateEnd});
    },
    setFlorist: (florist) => {
        set({
            florist,
            executions: [],
        })
    },
    getExecutions: (florist, forceReload = false, activeRing = true) => {
        if (get().type === ORDER_TYPE_PENDING) {
            get().getExecutionsInProgress(florist, forceReload, activeRing);
        } else {
            set({
                executionsCount: 0
            });
            get().fetchExecutions(florist, forceReload);
        }

    },
    getExecutionsInProgress: (florist, forceReload = false, activeRing = true) => {
        get().fetchExecutions(florist, forceReload).then(() => {
            let numberOfNewExecutionsInPending = 0;
            get().executionsInProgress.forEach(execution => {
                if (execution.etatextranet < 3) {
                    numberOfNewExecutionsInPending += 1;
                }
            })

            set({
                executionsInPendingCount: numberOfNewExecutionsInPending,
                activeRing,
            });

            get().setExecutionsAutoAccepted(get().executionsInProgress);
        });
    },
    fetchExecutions: async (florist, forceReload = false) => {
        set({isError: false});

        if (get().florist === null || get().florist.CodeFl !== florist.CodeFl) {
            set({florist});
        }

        const currentExecutions = get().type === ORDER_TYPE_PENDING ? get().executionsInProgress : get().executions;

        if (get().florist !== null && currentExecutions.length === 0 || forceReload) {
            set({isLoading: true});

            await ExecutionsAPI.getExecutions(
                get().type,
                get().sortType,
                get().sortOrder,
                get().currentPage,
                get().searchText,
                get().dateStart !== '' ? format(get().dateStart, 'dd-MM-yyyy HH:mm:ss') : '',
                get().dateEnd !== '' ? format(get().dateEnd, 'dd-MM-yyyy HH:mm:ss') : '',
                'ALL'
            ).then(({data}) => {
                if (data['hydra:member']) {
                    data = data['hydra:member'];
                }

                if (data.length === 0) {
                    set({isError: {
                            variant: 'warning',
                            icon: true,
                            content: 'Il n\'y a actuellement aucune exécution'
                        }}
                    );
                } else {
                    set({isError: false});
                }

                if (get().type === ORDER_TYPE_PENDING) {
                    set({
                        executionsInProgress: data,
                        executionsInProgressCount: data.length
                    });
                } else {
                    set({
                        executions: data,
                        executionsCount: data.length
                    });
                }

                set({isLoading: false});
            })
        }
    },
    setExecutionsInProgress: (numberOfNewExecutionsInPending, florist) => {
        set({
            activeRing: true,
            executionsInPendingCount: numberOfNewExecutionsInPending
        });

        if (get().type === ORDER_TYPE_PENDING) {
            get().getExecutionsInProgress(get().florist === null ? florist : get().florist, true);
        }
    },
    setExecutionsAutoAccepted: (executions) => { // Permet de rafraîchir le tableau des exécutions acceptées (livraison aujourd'hui)
        let numberOfNewExecutionsAutoAccepted = 0;
        executions.forEach(execution => {
            if (execution.etatextranet === 40) {
                numberOfNewExecutionsAutoAccepted += 1;
            }
        });

        if (numberOfNewExecutionsAutoAccepted !== get().executionsAutoAcceptedCount) {
            set({executionsAutoAcceptedCount: numberOfNewExecutionsAutoAccepted});
        }
    },
    resetType: () => {
        get().setType('pending');
    },
}))
